


















































import { defineComponent, onMounted, computed } from '@vue/composition-api';

import useRouter from '@/useRouter';
import ResultCard from '@/components/ResultCard.vue';

import { data } from '@/quiz';

const Result = defineComponent({
  setup(props) {
    const { router } = useRouter();

    const scoreInt = computed(() => {
      if (props.score === undefined) return undefined;
      return parseInt(props.score, 10);
    });

    onMounted(() => { window.scrollTo(0, 0); });

    onMounted(() => {
      if (scoreInt.value === undefined) router.push({ name: 'Quiz' });
    });

    function scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }

    const shareURL = computed(() => {
      const templateShare = 'https://quiz.hrh-abhakara-120anv-homecoming.com/result/SCORE.html';
      let url = templateShare.replace('SCORE', String(scoreInt.value).padStart(2, '0'));
      if (!scoreInt.value || scoreInt.value < 0 || scoreInt.value > 30) url = 'https://quiz.hrh-abhakara-120anv-homecoming.com/';
      return url;
    });
    function facebookShare() {
      console.log(shareURL.value);
      (window as any).FB.ui({
        method: 'share',
        href: shareURL.value,
      }, (response: any) => {
        if (response && !response.error_message) {
          console.log('Success!');
        } else {
          console.warn('Error while posting.');
        }
      });
    }

    function twitterShare() {
      const text = `ทดสอบความรู้ เรื่องพระประวัติเสด็จเตี่ย - พระประวัติระหว่างทรงศึกษาดำเนินไปอย่างไร ลองมาไล่เรียงกันดู ${shareURL.value}`;
      window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`, '_blank');
    }

    return {
      scrollTop,
      scoreInt,
      facebookShare,
      twitterShare,
      quizData: data,
    };
  },
  components: {
    ResultCard,
  },
  props: {
    score: {
      type: String,
    },
  },
});

export default Result;
